<template>
  <v-stepper-content step="3">
    <validation-observer v-slot="{ invalid }">
      <v-card class="mx-1 mb-12">
        <v-card-title>
          <div class="mr-4">
            {{ $t("form.labels.contact") }}
          </div>
          <v-btn
            small
            color="primary"
            @click="transferUserData"
            v-if="currentUser"
          >
            <v-icon small left>mdi-arrow-down</v-icon>
            {{
              $t("form.btn.transferData", { username: currentUser.username })
            }}
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="hidden-lg-and-up mb-n6">
            <v-col>
              <validation-provider
                name="Anrede"
                v-slot="{ errors }"
                rules="required"
              >
                <v-select
                  :label="$t('form.fields.salutation.label') + ' *'"
                  outlined
                  v-model="contact.salutation"
                  :items="genderTypes"
                  :error-messages="errors"
                ></v-select>
              </validation-provider>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                v-model="contact.title"
                :label="$t('form.fields.title')"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" class="hidden-md-and-down">
              <validation-provider
                name="Anrede"
                v-slot="{ errors }"
                rules="required"
              >
                <v-select
                  :label="$t('form.fields.salutation.label') + ' *'"
                  outlined
                  v-model="contact.salutation"
                  :items="genderTypes"
                  :error-messages="errors"
                ></v-select>
              </validation-provider>
            </v-col>
            <v-col>
              <validation-provider
                :name="$t('form.fields.firstname')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  :label="$t('form.fields.firstname') + ' *'"
                  outlined
                  v-model="contact.firstname"
                  :error-messages="errors"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col>
              <validation-provider
                :name="$t('form.fields.lastname')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  :label="$t('form.fields.lastname') + ' *'"
                  outlined
                  v-model="contact.lastname"
                  :error-messages="errors"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="2" class="hidden-md-and-down">
              <v-text-field
                outlined
                v-model="contact.title"
                :label="$t('form.fields.title')"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-n4">
            <v-col>
              <v-text-field
                :label="$t('form.fields.company')"
                outlined
                v-model="contact.name"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                :label="$t('form.fields.department')"
                outlined
                v-model="contact.department"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-n4">
            <v-col>
              <v-text-field
                :label="$t('form.fields.companyAddition')"
                outlined
                v-model="contact.companyAddition"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-n4">
            <v-col>
              <v-text-field
                :label="$t('form.fields.phone')"
                outlined
                v-model="contact.phone"
                type="tel"
              ></v-text-field>
            </v-col>
          </v-row>
          <validation-observer slim>
            <v-row class="mt-n4">
              <v-col>
                <validation-provider
                  :name="$t('form.fields.email')"
                  v-slot="{ errors }"
                  vid="original"
                  ref="emailField"
                  rules="required|email|confirmed:@confirm"
                >
                  <v-text-field
                    :label="$t('form.fields.email') + ' *'"
                    outlined
                    v-model="contact.email"
                    :error-messages="errors"
                    type="email"
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col>
                <validation-provider
                  :name="$t('form.fields.emailConfirmation')"
                  vid="confirm"
                  v-slot="{ errors }"
                  rules="required|email|confirmed:@original"
                >
                  <v-text-field
                    :label="$t('form.fields.emailConfirmation') + ' *'"
                    outlined
                    v-model="emailValidation"
                    @blur="validateEmailAddresses"
                    :error-messages="errors"
                    type="email"
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </validation-observer>
        </v-card-text>
      </v-card>
      <v-layout>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-4"
          @click="$emit('onContinue')"
          :disabled="invalid"
          >{{ $t("form.btn.continue") }}</v-btn
        >
        <v-btn text @click="$emit('onBack')">{{ $t("form.btn.back") }}</v-btn>
      </v-layout>
    </validation-observer>
  </v-stepper-content>
</template>

<script>
import { mapGetters } from "vuex";
import { GenderTypes } from "../../config/constants";

export default {
  props: ["multiple"],
  data() {
    return {
      emailValidation: null,
    };
  },
  methods: {
    transferUserData() {
      this.contact.salutation = this.currentUser.attributes.salutation;
      this.contact.firstname = this.currentUser.firstName;
      this.contact.lastname = this.currentUser.lastName;
      this.contact.title = this.currentUser.attributes.title;
      if (this.currentUser.attributes.hasCompanyAddress) {
        this.contact.name = this.currentUser.attributes.company;
        this.contact.department = this.currentUser.attributes.department;
        this.contact.companyAddition = this.currentUser.attributes.companyAddition;
      }
      this.contact.phone = this.currentUser.attributes.telephone;
      this.contact.email = this.currentUser.email;
      this.emailValidation = this.currentUser.email;
      this.$nextTick(() => {
        this.validateEmailAddresses();
      });
    },
    validateEmailAddresses() {
      this.$refs.emailField.validate();
    },
  },
  computed: {
    ...mapGetters(["currentUser", "contact"]),

    genderTypes() {
      return GenderTypes.map((t) => {
        return { value: t, text: this.$t(`form.fields.salutation.${t}`) };
      });
    },
  },
};
</script>

<style></style>
